import React from 'react'
import { Typography } from '@material-ui/core'
import clsx from 'clsx'

export default (props) => {
  const { title, description, className } = props

  return (
    <div className={clsx('flex flex-col flex-wrap', className)}>
      <Typography
        color="secondary"
        className="flex-shrink-0 flex-grow-0 w-full"
      >
        {title}
      </Typography>
      <Typography className="whitespace-normal">{description}</Typography>
    </div>
  )
}
